import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ServiceType } from '../_models/ServiceType';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { CueConfig } from '../_models/CueConfig';
import { CueAppService } from '../_services/cueApp.service';

@Component({
  templateUrl: './engine-config-create-modal.component.html',
  styleUrls: ['./engine-config-create-modal.component.css']
})

export class AppConfigCreateModalComponent implements OnInit {

  public loading = false;
  public form: FormGroup;

  @Input()
  public editing: boolean;

  @Output() hasError = new EventEmitter();

  public config: CueConfig;
  configId = -1;

  constructor(
    private bsModalRef: BsModalRef,
    private appService: CueAppService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService) { }

  close() {
    this.bsModalRef.hide();
  }

  saveAndClose() {
    if (!this.form.valid) {
      return;
    }

    this.loading = true;
    this.spinner.show();
    const newConfig: CueConfig = {
      cueConfigId: this.form.controls.cueConfigId.value,
      name: this.form.controls.name.value,
      path: this.form.controls.path.value,
      bucketName: this.form.controls.bucketName.value,
      value: this.form.controls.value.value,
      lastModified: this.config.lastModified,
      configType: this.config.configType
    };


    this.appService.updateConfig(newConfig)
    .subscribe(() => {
      this.loading = false;
      this.spinner.hide();
      this.hasError.emit(false);
      this.bsModalRef.hide();
    }, error => {
      this.loading = false;
      this.spinner.hide();
      this.hasError.emit(true);
      this.bsModalRef.hide();
    });
  }

  private initForm() {
    this.form = this.fb.group({
      cueConfigId: [0],
      name: ['', Validators.required],
      path: ['engine-configs/2019-07-02--four-configs', Validators.required], // fill with default
      bucketName: ['cueaudio.com-shared-configs', Validators.required], // fill with default
      value: ['', [
        ((): ValidatorFn => {
          return (control: AbstractControl): { [key: string]: any } | null => {
            let isValid;
            if (control.value !== null) {
              try {
                JSON.parse(control.value);
                isValid = true;
              } catch (e) {
                isValid = false;
              }
            }
            return isValid
              ? null
              : { 'json': { value: control.value } };
          };
        })()
      ]]
    });

  }

  ngOnInit() {
    this.loading = true;
    this.spinner.show();
    this.initForm();

    if (this.config != null) {
      this.form.controls.name.patchValue(this.config.name);
      this.form.controls.path.patchValue(this.config.path);
      this.form.controls.bucketName.patchValue(this.config.bucketName);
      this.form.controls.value.patchValue(this.config.value);
      this.form.controls.cueConfigId.patchValue(this.config.cueConfigId);
    }
    this.spinner.hide();
    this.loading = false;

  }
}

